/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        06/02/2020 16:19
 * @copyright   Copyright (c) 2002-2020 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import Modernizr from 'modernizr';
import LazyLoad from "vanilla-lazyload";

export default class Ux {
    
    static #shift = 0;
    
    constructor()
    {
        Ux.initializeJsClick();
        Ux.initializeBootstrapTooltip();
        Ux.initializeBootstrapPopover();
        Ux.initializeFancybox();
        Ux.initializeCookieOptIn();
        Ux.initializeSearchBox();
        Ux.initializeBackToTop();
        Ux.initializeSmoothScroll();
        Ux.initializeLazy();
        Ux.triggerMenuButton();
        Ux.manageLang();
        Ux.gtranslate();
    }
    
    static initializeJsClick()
    {
        if ( !Modernizr.touchevents ) {
            let ctrl = 0;
            $( window ).on( 'keydown', function ( e ) {
                if ( e.which == 17 || e.which == 91 ) {
                    
                    ctrl = true;
                }
            } );
            
            $( window ).on( 'keyup', function () {
                ctrl = false;
            } );
            
            $( document ).on( 'mouseup', '.js-click', function ( e ) {
                
                if ( e.which == 1 || e.which == 2 ) {
                    let blank = false;
                    let url   = $( this ).find( "a" ).attr( "href" );
                    if ( e.which == 2 ) {
                        blank = true;
                    } // Clic molette
                    if ( $( this ).find( "a" ).attr( "target" ) == "_blank" ) {
                        blank = true;
                    }
                    if ( blank || ctrl ) {
                        window.open( url, '_blank' );
                    } else {
                        window.location = url;
                    }
                    return false;
                }
                return false;
                
            } );
        } else {
            $( document ).on( 'click', '.js-click', function ( e ) {
                
                let blank = false;
                let url   = $( this ).find( "a" ).attr( "href" );
                if ( $( this ).find( "a" ).attr( "target" ) == "_blank" ) {
                    blank = true;
                }
                if ( blank ) {
                    window.open( url, '_blank' );
                } else {
                    window.location = url;
                }
                return false;
                
            } );
        }
    }
    
    static initializeBootstrapTooltip()
    {
        if ( !Modernizr.touchevents ) {
            $( '[data-toggle="tooltip"]' ).tooltip( { trigger: "hover" } );
        }
    }
    
    static initializeBootstrapPopover()
    {
        $( '[data-toggle="popover"]' ).popover( { trigger: 'focus' } );
    }
    
    static initializeFancybox()
    {
        
        $( '.article a:has(>img):not([target="_blank"]):not("[nofancybox]")' ).attr( 'data-fancybox', 'fancybox' );
        
        $( "[data-fancybox='fancybox']" ).fancybox( {
                                                        buttons: [
                                                            "zoom",
                                                            //"share",
                                                            "slideShow",
                                                            //"fullScreen",
                                                            //"download",
                                                            //"thumbs",
                                                            "close"
                                                        ],
                                                        lang: "fr",
                                                        i18n: {
                                                            fr: {
                                                                CLOSE: Theme.translate.fancyboxClose,
                                                                NEXT: Theme.translate.fancyboxNext,
                                                                PREV: Theme.translate.fancyboxPrev,
                                                                ERROR: Theme.translate.fancyboxError,
                                                                PLAY_START: Theme.translate.fancyboxStart,
                                                                PLAY_STOP: Theme.translate.fancyboxStop,
                                                                FULL_SCREEN: Theme.translate.fancyboxFullScreen,
                                                                THUMBS: Theme.translate.fancyboxThumbs,
                                                                DOWNLOAD: Theme.translate.fancyboxDownload,
                                                                SHARE: Theme.translate.fancyboxShare,
                                                                ZOOM: Theme.translate.fancyboxZoom
                                                            },
                                                        },
                                                        caption: function ( instance, item ) {
                                                            let caption = $( this ).closest( 'figure' ).find( 'figcaption' ).html();
                
                                                            if ( !caption ) {
                                                                caption = $( this ).find( 'img' ).attr( 'title' );
                                                            }
                
                                                            if ( !caption ) {
                                                                caption = $( this ).find( 'img' ).attr( 'alt' );
                                                            }
                
                                                            return caption;
                                                        }
                                                    } );
    }
    
    static initializeCookieOptIn()
    {
        tarteaucitron.init( {
                                "useExternalCss": false,
                                "privacyUrl": Theme.privacyPolicyURL,
            
                                "hashtag": "",
                                "cookieName": "tartaucitron",
            
                                "orientation": "bottom",
                                "showAlertSmall": false,
                                "cookieslist": true,
            
                                "adblocker": false,
                                "AcceptAllCta": true,
                                "highPrivacy": true,
                                "handleBrowserDNTRequest": false,
            
                                "removeCredit": true,
                                "moreInfoLink": true,
                                "showExitButton": true
                            } );
        
        tarteaucitronForceLanguage = Theme.current_locale;
        (tarteaucitron.job = tarteaucitron.job || []).push( 'wordpress' );
        (tarteaucitron.job = tarteaucitron.job || []).push( 'recaptcha' );
        (tarteaucitron.job = tarteaucitron.job || []).push( 'gtag' );
    }
    
    static initializeSearchBox()
    {
        $( '.js-wpSearchLayoutOpen' ).on( 'click', function ( e ) {
            e.preventDefault();
            $( '.wpSearchLayout' ).fadeIn();
            setTimeout( function () {
                $( '.wpSearchFormItem--input' ).focus();
            }, 100 );
        } );
        
        $( '.js-wpSearchLayoutClose' ).on( 'click', function ( e ) {
            e.preventDefault();
            $( '.wpSearchLayout' ).fadeOut();
        } );
    }
    
    static initializeBackToTop()
    {
        $( '.js-backToTop' ).on( 'click', function ( e ) {
            e.preventDefault();
            
            if ( $( window ).scrollTop() != 0 ) {
                $( 'html, body' ).animate( { scrollTop: 0 }, 300 );
            }
        } );
        
        $( window ).on( 'scroll', function ( e ) {
            
            if ( $( this ).scrollTop() > 250 ) {
                $( '.js-backToTop' ).addClass( 'backToTop--show' );
            } else {
                $( '.js-backToTop' ).removeClass( 'backToTop--show' );
            }
        } );
    }
    
    static initializeSmoothScroll( shift = Ux.#shift )
    {
        $( '.js-scroll' ).unbind( 'click' );
        $( '.js-scroll' ).bind( 'click', ( e ) => {
            e.preventDefault();
            let target   = $( e.currentTarget ).attr( 'href' );
            let duration = 1000;
            let scrollTop = $( target ).offset().top - ( undefined !== e.currentTarget.dataset.shift ? e.currentTarget.dataset.shift : shift );
            $( 'html, body' ).animate( {
                                           scrollTop: scrollTop
                                       }, duration );
            
        } );
    }
    
    static initializeLazy()
    {
        let lazyLoadInstance = new LazyLoad( {
                                                 elements_selector: "[data-src], [data-bg]"
                                             } );
    }
    
    static triggerMenuButton()
    {
        const button  = $( '#buttonMobile' ),
              mainnav = $( '.mainnav' );
        
        if ( button.length > 0 ) {
            button.on( 'change', function () {
                if ( $( this ).is( ':checked' ) ) {
                    mainnav.addClass( 'open' );
                    $('body').css('overflow', 'hidden');
                } else {
                    mainnav.removeClass( 'open' );
                    $('body').css('overflow', 'initial');
                }
            } );
        }
    }
    
    static manageLang()
    {
        const $trigger = $( '[data-trigger="wpiris-choice-lang"]' );
        
        $trigger.on( 'click', function() {
            const target = $( this ).attr( 'data-element' );
            $( '[data-id='+ target +']' ).toggleClass( 'open' );
        });
        
        $( document ).on( 'change', '#choiceLang', function() {
            const site_url = $( this ).val();
            window.location.href = site_url;
        });
    }

    static gtranslate() {

        $('.toolsItemLangs a').on( 'click', function ( e ) {
            updateCurrentLanguageTopbar();
        } );

        const updateCurrentLanguageTopbar = function () {

            window.setTimeout( function () {

                let current_language = $( 'html' ).attr( 'lang' ).replace( /-.*/gi, '' );

                if( current_language === 'auto' ) {
                    current_language = 'FR';
                }

                $('.toolsItem--lang .current').text( current_language.toUpperCase() );

                $('.toolsItemLangs a').each(function() {
                    if ($(this).text() === current_language.toUpperCase() || ($(this).text() === 'auto' && current_language === 'FR')) {
                        $(this).css('display', 'none');
                    } else {
                        $(this).css('display', 'block');
                    }
                })

            }, 500 );
        };

        $( window ).on( 'load', function () {
            setTimeout( function() {
                updateCurrentLanguageTopbar();

                $('.toolsItemLangs a[title="Français"]').attr('href', 'https://www.mandelieu-tourisme.com/');
            }, 500)
        } );

    }
}
